// Navbar controller for handling mobile menu toggle, user dropdown, and practice menu

// Clear any existing event listeners to prevent duplicates
function clearExistingListeners() {
  const oldUserMenuButton = document.getElementById('user-menu-button');
  if (oldUserMenuButton) {
    const newUserMenuButton = oldUserMenuButton.cloneNode(true);
    oldUserMenuButton.parentNode.replaceChild(newUserMenuButton, oldUserMenuButton);
  }

  const oldMobileMenuButton = document.querySelector('.mobile-menu-button');
  if (oldMobileMenuButton) {
    const newMobileMenuButton = oldMobileMenuButton.cloneNode(true);
    oldMobileMenuButton.parentNode.replaceChild(newMobileMenuButton, oldMobileMenuButton);
  }

  const oldPracticeButton = document.getElementById('practice-button');
  if (oldPracticeButton) {
    const newPracticeButton = oldPracticeButton.cloneNode(true);
    oldPracticeButton.parentNode.replaceChild(newPracticeButton, oldPracticeButton);
  }

  const oldMobilePracticeButton = document.getElementById('mobile-practice-button');
  if (oldMobilePracticeButton) {
    const newMobilePracticeButton = oldMobilePracticeButton.cloneNode(true);
    oldMobilePracticeButton.parentNode.replaceChild(newMobilePracticeButton, oldMobilePracticeButton);
  }

  const oldCoursesDropdownButton = document.querySelector('.courses-dropdown-button');
  if (oldCoursesDropdownButton) {
    const newCoursesDropdownButton = oldCoursesDropdownButton.cloneNode(true);
    oldCoursesDropdownButton.parentNode.replaceChild(newCoursesDropdownButton, oldCoursesDropdownButton);
  }

  const oldMobileCoursesButton = document.getElementById('mobile-courses-button');
  if (oldMobileCoursesButton) {
    const newMobileCoursesButton = oldMobileCoursesButton.cloneNode(true);
    oldMobileCoursesButton.parentNode.replaceChild(newMobileCoursesButton, oldMobileCoursesButton);
  }
}

// Function to initialize navbar functionality
function initializeNavbar() {

  // Clear existing listeners first
  clearExistingListeners();

  // Mobile menu functionality
  const mobileMenuButton = document.querySelector('.mobile-menu-button');
  const mobileMenu = document.getElementById('mobile-menu');

  if (mobileMenuButton && mobileMenu) {
    // Add click event listener to the mobile menu button
    mobileMenuButton.addEventListener('click', () => {
      // Toggle the hidden class on the mobile menu
      mobileMenu.classList.toggle('hidden');

      // Toggle the icon (hamburger/x)
      const hamburgerIcon = mobileMenuButton.querySelector('svg.block');
      const closeIcon = mobileMenuButton.querySelector('svg.hidden');

      if (hamburgerIcon && closeIcon) {
        hamburgerIcon.classList.toggle('hidden');
        hamburgerIcon.classList.toggle('block');
        closeIcon.classList.toggle('hidden');
        closeIcon.classList.toggle('block');
      }
    });
  }

  // Practice menu dropdown functionality
  const practiceButton = document.getElementById('practice-button');
  const subjectsDropdown = document.getElementById('subjects-dropdown');

  if (practiceButton && subjectsDropdown) {
    practiceButton.addEventListener('click', function(event) {
      event.stopPropagation();
      subjectsDropdown.classList.toggle('hidden');

      // Toggle arrow direction
      const arrow = practiceButton.querySelector('svg');
      if (subjectsDropdown.classList.contains('hidden')) {
        arrow.classList.remove('rotate-180');
      } else {
        arrow.classList.add('rotate-180');
      }
    });
  }

  // Mobile practice menu dropdown functionality
  const mobilePracticeButton = document.getElementById('mobile-practice-button');
  const mobileSubjectsDropdown = document.getElementById('mobile-subjects-dropdown');

  if (mobilePracticeButton && mobileSubjectsDropdown) {
    mobilePracticeButton.addEventListener('click', function(event) {
      event.stopPropagation();
      mobileSubjectsDropdown.classList.toggle('hidden');

      // Toggle arrow direction
      const arrow = mobilePracticeButton.querySelector('svg');
      if (mobileSubjectsDropdown.classList.contains('hidden')) {
        arrow.classList.remove('rotate-180');
      } else {
        arrow.classList.add('rotate-180');
      }
    });
  }

  // Courses dropdown functionality (Desktop)
  const coursesDropdownButton = document.querySelector('.courses-dropdown-button');
  const coursesDropdownMenu = document.querySelector('.courses-dropdown-menu');

  if (coursesDropdownButton && coursesDropdownMenu) {
    coursesDropdownButton.addEventListener('click', function(event) {
      event.stopPropagation();
      coursesDropdownMenu.classList.toggle('hidden');

      // Toggle arrow direction
      const arrow = coursesDropdownButton.querySelector('svg');
      if (coursesDropdownMenu.classList.contains('hidden')) {
        arrow.classList.remove('rotate-180');
      } else {
        arrow.classList.add('rotate-180');
      }
    });
  }

  // Mobile courses menu dropdown functionality
  const mobileCoursesButton = document.getElementById('mobile-courses-button');
  const mobileCoursesDropdown = document.getElementById('mobile-courses-dropdown');

  if (mobileCoursesButton && mobileCoursesDropdown) {
    mobileCoursesButton.addEventListener('click', function(event) {
      event.stopPropagation();
      mobileCoursesDropdown.classList.toggle('hidden');

      // Toggle arrow direction
      const arrow = mobileCoursesButton.querySelector('svg');
      if (mobileCoursesDropdown.classList.contains('hidden')) {
        arrow.classList.remove('rotate-180');
      } else {
        arrow.classList.add('rotate-180');
      }
    });
  }

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(event) {
    // Desktop practice dropdown
    const subjectsDropdown = document.getElementById('subjects-dropdown');
    const practiceButton = document.getElementById('practice-button');

    if (subjectsDropdown && practiceButton) {
      const isClickInside = practiceButton.contains(event.target) || subjectsDropdown.contains(event.target);

      if (!isClickInside && !subjectsDropdown.classList.contains('hidden')) {
        subjectsDropdown.classList.add('hidden');
        practiceButton.querySelector('svg').classList.remove('rotate-180');
      }
    }

    // Mobile practice dropdown
    const mobileSubjectsDropdown = document.getElementById('mobile-subjects-dropdown');
    const mobilePracticeButton = document.getElementById('mobile-practice-button');

    if (mobileSubjectsDropdown && mobilePracticeButton) {
      const isClickInside = mobilePracticeButton.contains(event.target) || mobileSubjectsDropdown.contains(event.target);

      if (!isClickInside && !mobileSubjectsDropdown.classList.contains('hidden')) {
        mobileSubjectsDropdown.classList.add('hidden');
        mobilePracticeButton.querySelector('svg').classList.remove('rotate-180');
      }
    }

    // Desktop courses dropdown
    const coursesDropdownMenu = document.querySelector('.courses-dropdown-menu');
    const coursesDropdownButton = document.querySelector('.courses-dropdown-button');

    if (coursesDropdownMenu && coursesDropdownButton) {
      const isClickInside = coursesDropdownButton.contains(event.target) || coursesDropdownMenu.contains(event.target);

      if (!isClickInside && !coursesDropdownMenu.classList.contains('hidden')) {
        coursesDropdownMenu.classList.add('hidden');
        coursesDropdownButton.querySelector('svg').classList.remove('rotate-180');
      }
    }

    // Mobile courses dropdown
    const mobileCoursesDropdown = document.getElementById('mobile-courses-dropdown');
    const mobileCoursesButton = document.getElementById('mobile-courses-button');

    if (mobileCoursesDropdown && mobileCoursesButton) {
      const isClickInside = mobileCoursesButton.contains(event.target) || mobileCoursesDropdown.contains(event.target);

      if (!isClickInside && !mobileCoursesDropdown.classList.contains('hidden')) {
        mobileCoursesDropdown.classList.add('hidden');
        mobileCoursesButton.querySelector('svg').classList.remove('rotate-180');
      }
    }
  });

  // User dropdown menu functionality
  const userMenuButton = document.getElementById('user-menu-button');
  const userDropdown = document.getElementById('user-dropdown');

  if (userMenuButton && userDropdown) {
    // Toggle dropdown when clicking the profile picture
    userMenuButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      userDropdown.classList.toggle('hidden');
    });
  }

  // Global click handler to close dropdowns
  document.addEventListener('click', (event) => {
    const userMenuButton = document.getElementById('user-menu-button');
    const userDropdown = document.getElementById('user-dropdown');
    const mobileMenuButton = document.querySelector('.mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');

    // Handle user dropdown
    if (userMenuButton && userDropdown && !userMenuButton.contains(event.target) && !userDropdown.contains(event.target)) {
      userDropdown.classList.add('hidden');
    }

    // Handle mobile menu
    if (mobileMenuButton && mobileMenu && !mobileMenuButton.contains(event.target) && !mobileMenu.contains(event.target) && !mobileMenu.classList.contains('hidden')) {
      mobileMenu.classList.add('hidden');

      // Reset icons
      const hamburgerIcon = mobileMenuButton.querySelector('svg:first-child');
      const closeIcon = mobileMenuButton.querySelector('svg:last-child');

      if (hamburgerIcon && closeIcon) {
        hamburgerIcon.classList.remove('hidden');
        hamburgerIcon.classList.add('block');
        closeIcon.classList.add('hidden');
        closeIcon.classList.remove('block');
      }
    }
  });
}

document.addEventListener('turbo:load', () => {
  initializeNavbar();
});
